import styled from "styled-components";

export const AppWrapper = styled.div`
  border-top: 8px #da291c solid;
  display: flex;
  flex-direction: column;
`;

export const AppContent = styled.div`
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
`;

export const AppLogoWrapper = styled.div`
  display: flex;
  height: 300px;
`;

export const AppLogo = styled.img`
  margin: auto auto 110px;
  width: 300px;
  height: 98px;
`;

export const ContentWrapper = styled.div`
  border: 1px solid #4e5866;
  height: 330px;
  width: 450px;
  margin: 0 auto;
  background: #262b30;
`;
export const Footer = styled.div`
  background: #31353b;
  border: 1px solid #4e5866;
  width: 216px;
  height: 50px;
  margin: auto auto 20px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  padding: 6px;
  box-sizing: border-box;
  justify-content: center;
  display: flex;
  flex-direction: column;
  & p {
    margin: 0;
    padding: 0;
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
`;

export const AboutPageWrapper = styled.div`
  & [role="tab"] {
    &:hover {
      background: color-mix(in srgb, var(--brand), transparent 70%);
    }
    & > div {
      & span:hover,
      &:hover {
        background: none;
      }
    }
  }
`;
